import { render, staticRenderFns } from "./ProofOfInvestment.vue?vue&type=template&id=2a2a6b6e&scoped=true"
import script from "./ProofOfInvestment.vue?vue&type=script&lang=js"
export * from "./ProofOfInvestment.vue?vue&type=script&lang=js"
import style0 from "./ProofOfInvestment.vue?vue&type=style&index=0&id=2a2a6b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a6b6e",
  null
  
)

export default component.exports